import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import {
  LOYALTY_ICON,
  LOYALTY_ICON_FILLED,
} from "../../../../redo-suite/marketing-cloud";

export const LoyaltyItems = memo(function LoyaltyItems() {
  const team = useRequiredContext(TeamContext);
  const routes = useRequiredContext(MerchantRoutesContext);

  const loyaltyEnabled = team?.settings.marketing?.loyalty?.enabled;

  const loyaltyBaseUrl = routes.marketingBaseUrl + "/loyalty";
  const anyChildSelected = useMatch(`${loyaltyBaseUrl}/*`);

  if (!loyaltyEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getLoyaltySubRoute("program") }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={LOYALTY_ICON_FILLED}
      friendlyName="Loyalty"
      id="loyalty"
      UnfilledIcon={LOYALTY_ICON}
    >
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getLoyaltySubRoute("program") }}
        friendlyName="Points program"
        id="loyalty-program"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getLoyaltySubRoute("promotions") }}
        friendlyName="Promotions"
        id="loyalty-promotions"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getLoyaltySubRoute("on-site") }}
        friendlyName="On-site"
        id="loyalty-on-site"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getLoyaltySubRoute("members") }}
        friendlyName="Members"
        id="loyalty-members"
      />
    </RedoSecondaryNavItem>
  );
});
